import { Typography } from '@mui/material'

interface Props {
  containerNumbers: string[]
  containerIds: number[]
}

export const IssueCardContainerList = ({ containerNumbers, containerIds }: Props) => (
  <Typography variant='body2'>
    {containerNumbers.filter(Boolean).join(', ') || containerIds.join(', ')}
  </Typography>
)
